import { forwardRef } from 'react';
import { Button } from 'react-bootstrap';
import { BiPencil, BiPlus, BiTrash } from 'react-icons/bi';
import './perfil-tabs-acoes.css';

type TipoAcaoPerfil = 'adicionar' | 'editar' | 'excluir';

const ACOES = {
  adicionar: {
    variant: 'outline-primary',
    Icon: BiPlus,
    className: 'perfil-btn-adicionar',
    labelPadrao: 'Adicionar',
  },
  editar: {
    variant: 'outline-primary',
    Icon: BiPencil,
    className: '',
    labelPadrao: 'Editar',
  },
  excluir: {
    variant: 'outline-danger',
    Icon: BiTrash,
    className: '',
    labelPadrao: 'Excluir',
  },
} as const;

type Props = {
  tipo: TipoAcaoPerfil;
  onClick: () => void;
  children?: React.ReactNode;
  disabled?: boolean;
  title?: string;
  className?: string;
};

export const BotaoAcaoPerfil = forwardRef<HTMLButtonElement, Props>(function BotaoAcaoPerfil(
  { tipo, onClick, children, disabled, title, className },
  ref,
) {
  const { variant, Icon, className: classeTipo, labelPadrao } = ACOES[tipo];
  const label = children ?? labelPadrao;

  return (
    <Button
      ref={ref}
      type="button"
      variant={variant}
      size="sm"
      disabled={disabled}
      title={title}
      className={`d-inline-flex align-items-center gap-1 ${classeTipo} ${className ?? ''}`.trim()}
      onClick={onClick}
    >
      <Icon size={14} aria-hidden />
      {label}
    </Button>
  );
});
